module.exports = __webpack_public_path__ + "static/images/styles/images/popover-footer-divider.e570c02a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/popover-footer-divider.png
// module id = 3680
// module chunks = 11